<template>
    <nav
        class="navbar navbar-light bottom-nvb"
    >
        <div class="row nav-container">
            <router-link tag="div" class="col-2 nav-item" :to="{name: 'Khanesh'}" :class="{ 'khanesh-active': route == 'Khanesh'}">
                <template v-if="route == 'Khanesh'">
                    <img :src="cKhanesh" alt="Khanesh">
                </template>
                <template v-else>
                    <img :src="Khanesh" alt="Khanesh">
                    <small>خانه</small>
                </template>
            </router-link>
            <router-link 
                tag="div" class="col-2 nav-item" :to="{name: 'Barjestegi'}" 
                :class="{ 'barjestegi-active': route == 'Barjestegi'}"
            >
                <template v-if="route == 'Barjestegi'">
                    <img :src="cBarjestegi" alt="Barjestegi">
                </template>
                <template v-else>
                    <img :src="Barjestegi" alt="Barjestegi">
                    <small>دوره‌ها</small>
                </template>
            </router-link>
            <router-link 
                tag="div" class="col-2 nav-item" :to="{name: 'Video'}" 
                :class="{ 'resaneh-active':  ['Webinar', 'Video', 'Podcast'].indexOf(route) != -1}"
            >
                <template v-if="['Webinar', 'Video', 'Podcast'].indexOf(route) != -1">
                    <img :src=" cResaneh" alt="Resaneh">
                </template>
                <template v-else>
                    <img :src="Resaneh" alt="Resaneh">
                    <small>رسانه</small>
                </template>
            </router-link>
            <div 
                disabled
                class="col-2 nav-item"
            >
                <small class="soon">بزودی</small>
                <img id="BlurImg" :src="Goftogoo" alt="Goftogoo">
                <small>گفتگو</small>
            </div>
            <router-link 
                tag="div" class="col-2 nav-item" :to="{name: 'Advisor'}"
                :class="{ 'advisor-active': route == 'Advisor'}"
            >
                <template v-if="route == 'Advisor'">
                    <img :src="cMoshavaereh" alt="Moshavaereh">
                </template>
                <template v-else>
                    <img :src="Moshavaereh" alt="Moshavaereh">
                    <small>مشاوره</small>
                </template>
            </router-link>
        </div>
    </nav>
</template>

<script>
import Khanesh from '@/assets/images/footer/khanesh.png';
import Barjestegi from '@/assets/images/footer/barjestegi.png';
import Resaneh from '@/assets/images/footer/resaneh.png';
import Goftogoo from '@/assets/images/footer/goftogoo.png';
import Moshavaereh from '@/assets/images/footer/moshavaereh.png';

import cKhanesh from '@/assets/images/footer/ckhanesh.png';
import cBarjestegi from '@/assets/images/footer/cbarjestegi.png';
import cResaneh from '@/assets/images/footer/cresaneh.png';
import cMoshavaereh from '@/assets/images/footer/cmoshavaereh.png';

export default {
    name: 'Footer',
    data() {
        return {
            Khanesh: Khanesh,
            Barjestegi: Barjestegi,
            Resaneh: Resaneh,
            Goftogoo: Goftogoo,
            Moshavaereh: Moshavaereh,

            cKhanesh: cKhanesh,
            cBarjestegi: cBarjestegi,
            cResaneh: cResaneh,
            cMoshavaereh: cMoshavaereh,

            route: this.$route.name,
        }
    },
    watch: {
        '$route'() {
            this.route = this.$route.name;
        }
    },
    methods: {
        showAlert() {
            this.$modal.show('dialog', {
                title: 'توجه!',
                text: 'صفحه جاری در حال حاضر در حال طراحی می‌باشد و موقتا قابل نمایش نمی‌باشد',
                buttons: [
                    {
                        title: 'بستن',
                        default: true,
                    }
                ]
            });
        }
    }
}
</script>

<style scoped>
.fa-size {
    font-size: 2rem;
}
.bottom-nvb {
    height: 50pt;
    background-color: #fff;

    display: flex;
    flex-direction: row;

    padding: 0 !important;
}
.bottom-nvb .nav-container {
    width: 100%;
    margin: 0 15pt;
}
.bottom-nvb .nav-container .nav-item {
    height: 35pt;
    margin: auto;
    padding: 0 !important;

    border-radius: 10pt;
    box-shadow: 2px 2px 8px 0px #ddd;
    cursor: pointer;

    display: flex;
    flex-direction: column;
    text-align: center;
}
.bottom-nvb .nav-container .nav-item .soon {
    position: absolute;
    transform: rotate(-45deg);
    left: 3px;
    top: 3px;
    color: red;
    font-weight: bold;
    font-size: 12px;
    z-index: 1;
}
.bottom-nvb .nav-container .nav-item img {
    height: 10pt;
    margin: auto auto 3pt;
}
.bottom-nvb .nav-container .nav-item #BlurImg {
    filter: blur(.5px); 
    opacity: 0.5;
}
.bottom-nvb .nav-container .nav-item small {
    font-size: 60%;
    margin: 3pt auto auto;
    display: inline-block;
}
.bottom-nvb .nav-container .khanesh-active {
    box-shadow: inset 0px 2px 5px 1px  #cea600;
    background-color: #ffce02;
}
.bottom-nvb .nav-container .advisor-active,
.bottom-nvb .nav-container .barjestegi-active {
    box-shadow: inset 0px 2px 5px 1px  #20a549e8;
    background-color: #2ad85f;
}
.bottom-nvb .nav-container .resaneh-active {
    box-shadow: none;
    background-image: conic-gradient(at 50% 50%, #00c9ff, #fece02, #46ff7e, #00c9ff);
}
.bottom-nvb .nav-container .advisor-active img,
.bottom-nvb .nav-container .khanesh-active img,
.bottom-nvb .nav-container .barjestegi-active img {
    height: 12pt;
    margin: auto;
}
.bottom-nvb .nav-container .resaneh-active img {
    height: 28pt;
    margin: auto;   
}
</style>

